import { clsx } from 'clsx'
import type { HTMLAttributes, ReactNode } from 'react'

import styles from './styles.module.scss'
export interface IconProps extends HTMLAttributes<HTMLDivElement> {
  color?: string
  icon: ReactNode
  size?: string | number
}

export function Icon({ icon, color, size, className, ...props }: IconProps) {
  return (
    <div
      {...props}
      className={clsx(className, styles.container)}
      style={{ color, width: size, height: size }}
    >
      {icon}
    </div>
  )
}
